
export function clickTheCanvas() {
    const canvasElement = document.getElementById("upperCanvas")
    if (canvasElement) {
        canvasElement.dispatchEvent(new Event('mousedown'));
    }
}